import { CSS_DRAGOVER_CLASS } from './upload-constants';

export const attachUploadEventListeners = ({ zone, fileInput, isAtLimit, isPreviewInteractionTarget, openFilePicker, handleFileSelection }) => {
	zone.addEventListener('click', (event) => {
		const target = event.target;
		if (target instanceof HTMLElement && isPreviewInteractionTarget(target)) {
			return;
		}

		event.preventDefault();
		if (isAtLimit()) {
			return;
		}

		openFilePicker();
	});

	fileInput.addEventListener('change', () => {
		handleFileSelection(fileInput.files);
		fileInput.value = '';
	});

	zone.addEventListener('dragover', (event) => {
		event.preventDefault();
		if (isAtLimit()) {
			zone.classList.remove(CSS_DRAGOVER_CLASS);
			if (event.dataTransfer) {
				event.dataTransfer.dropEffect = 'none';
			}
			return;
		}

		zone.classList.add(CSS_DRAGOVER_CLASS);
	});

	zone.addEventListener('dragleave', (event) => {
		event.preventDefault();
		zone.classList.remove(CSS_DRAGOVER_CLASS);
	});

	zone.addEventListener('drop', (event) => {
		event.preventDefault();
		zone.classList.remove(CSS_DRAGOVER_CLASS);
		handleFileSelection(event.dataTransfer?.files || []);
	});
};
